import { render, staticRenderFns } from "./GradeSchool.vue?vue&type=template&id=0db34ce4&scoped=true"
import script from "./GradeSchool.vue?vue&type=script&lang=js"
export * from "./GradeSchool.vue?vue&type=script&lang=js"
import style0 from "./GradeSchool.vue?vue&type=style&index=0&id=0db34ce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db34ce4",
  null
  
)

export default component.exports